var productsComparison = {
    products : [],
	init : function(){
		productsComparison.updateCompareCheckboxes();
				
		if(getCookie('compare')!= null){
			$('.products-comparison-modal').addClass('with-products');
		}
		
		$(".products-comparison-modal.with-products").bind( "clickoutside", function(event){
			if($('body').hasClass('show-compare-modal')){
				productsComparison.closeCompareModal();
			}	
		});
		$('.products-comparison-modal .close-compare').click(function(){
			if($('body').hasClass('show-compare-modal')){
				productsComparison.closeCompareModal();
			}else{
				productsComparison.openCompareModal();
			}
			return false;
		});
		$('.products-comparison .features-list .feature_info').click(function(){
			if($(this).parent().hasClass('open')){
				$(this).parent().removeClass('open');
			}else{
				$('.features-list .open').removeClass('open');	
				$(this).parent().toggleClass('open');	
			}
			
			return false;
		});
		$('.products-comparison .features-list .dropdown-menu .close-info').click(function(){
			$('.products-comparison .features-list li.open').removeClass('open');
			return false;
		});

		
		$('.products-comparison .scroll-controls .left').click(function(){
			scroller.mCustomScrollbar("scrollTo",'left');
			return false;
		});
		$('.products-comparison .scroll-controls .right').click(function(){
			scroller.mCustomScrollbar("scrollTo",'right');
			return false;
		});
		
		$('.products-comparison .same-prices input[type="checkbox"]').change(function(){
			var $this = $(this);
			if(!$this.is(":checked")){
				$('.features-list:visible ul li').each(function(){
					var start = 0;
					var value = '';
					var hide = true;
					var attribute = $(this).data('attribute');
					$('.compare-products-list-features:visible ul li[data-attribute="'+attribute+'"]').each(function(){
						if(start === 0){
							value =  $(this).data('value');	
							start = 1;
						}
						if(value !== $(this).data('value')){
						 	hide =false;
						}
					});
					
					if(hide){
						$('.features-list ul li[data-attribute="'+attribute+'"]').addClass('hidden');
						$('.compare-products-list-features ul li[data-attribute="'+attribute+'"]').addClass('hidden');
					}
				});
			}else{
				$('.compare-products-list-features ul li.hidden').removeClass('hidden');
				$('.features-list ul li.hidden').removeClass('hidden');
			}
		});	
		
		
		
		
		var scroller = $(".compare-products-list-features.mobile .block-content").mCustomScrollbar({
			axis:"x",
			advanced:{
				autoExpandHorizontalScroll:true
			}
		});

		
	},
	checkboxChange : function($this){		
		if($this.is(":checked")){
			productsComparison.addToCompare($this.val()); 
		}else{
			productsComparison.removeFromCompare($this.val());
		}
	},
	addToCompare : function($id){
        if( this.products.length == 4){
            $('.limit-indicator').removeClass('hidden');
            productsComparison.updateCompareCheckboxes();
            return false;
        }else if(this.products.indexOf($id) == -1){
            this.products.push($id);
        }
        productsComparison.openCompareModal();
        $('.products-comparison-modal .compare-content').data('ids',this.products.join(','));
        load_partial($('.products-comparison-modal .compare-content'));
        $('.comparison-modal-header a.compare-products').attr('href','/en/products-comparison?ids=' + this.products.join(','));
        $('.products-comparison-modal').addClass('with-products');


	},
	removeFromCompare : function($id){
        $id = String($id);
        $('.comparison-products-grid .products-comparison-item.id_'+$id).remove();

        this.products = findGetParameter('ids').split(',');

        if(this.products.indexOf($id) != -1){
            this.products.splice(this.products.indexOf($id), 1);
        }

        console.log(this.products);
        if( this.products.length == 0){
            $('.limit-indicator').addClass('hidden');
            productsComparison.updateCompareCheckboxes();
            productsComparison.closeCompareModal();

            $('.products-comparison-modal').removeClass('with-products');
            productsComparison.updateCompareCheckboxes();
        }


        if($('.products-comparison').length > 0){
            window.location.href = CURRENT_URL  + '?ids=' + this.products.join(',');
        }else{
            $('.comparison-modal-header a.compare-products').attr('href','/en/products-comparison?ids=' + this.products.join(','));

        }



	},
	templateAddCompare : function($id){		
		var template =  $('.temp .products-comparison-item.hidden').eq($('.comparison-products-grid .products-comparison-item').length - 1);
		template.find('.products-comparison-item');		
		$('.comparison-products-grid').append('<div class="products-comparison-item hidden">'+ template.html() +'</div>');
		$('.comparison-products-grid .products-comparison-item.hidden').addClass('id_'+$id);
		$('.comparison-products-grid .products-comparison-item .remove-from-compare').data( "id", $id ).click(function(){
			var $this = $(this);
			productsComparison.removeFromCompare($this.data('id'));
			return false;
		});
		$('.comparison-products-grid .products-comparison-item.hidden').removeClass('hidden');

        if(CURRENT_PATH  == 'en/products-comparison' ){
            window.location = '/en/products-comparison?ids=' + this.products.join(',');
        }


	},
	

	closeCompareModal : function(){
		$('body').removeClass('show-compare-modal');
		return false;
	},
	openCompareModal : function(){
		$('body').addClass('show-compare-modal');
		return false;
	},
	updateCompareCheckboxes : function(){
		$('.comparison-products-grid').empty();
		var $cookie = getCookie('compare');
		if(typeof $cookie !== "undefined" && $cookie != null && $cookie!='' ){
			var separator =  ",";
			var values = $cookie.split(separator);
			$('.compare-check input[type="checkbox"]').each(function(){
				var $checkbox = $(this);
				var $id = $checkbox.val();
				for(var i = 0 ; i < values.length ; i++) {
					if(values[i] == $id) {
						$checkbox.prop("checked", true);
					}
				}
			});	
			for(var i = 0 ; i < values.length ; i++) {
				productsComparison.templateAddCompare(values[i]);
			}
		}		
		return false;
	}
};


function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}



